import { Box } from '@mui/material';
import zeplinColor from 'theme/Color';
import { muiStyles } from './muiStyles';

const DotDivider = ({ color }: { color?: string }) => {
  const backgroundColor = color ? color : zeplinColor.BasicBlack;

  return <Box sx={{ ...muiStyles.dotDivider, backgroundColor }} />;
};

export default DotDivider;
